import FetchData from '@shared/utils/fetchData/fetchData';

export const addProductToFavorites = async (products: string[]) => {
  return await FetchData.post<{ message: string }>('favourites', {
    body: JSON.stringify({ products })
  });
};
